<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="70%">
      <v-form ref="formUser" v-model="valid" lazy-validation @submit.prevent="updateDataMoodle">
        <v-card>
          <v-card-title class="primary white--text">{{
            register ? 'Registrar en Moodle' : 'Actualizar Datos Moodle'
          }}</v-card-title>
          <v-card-text class="pa-4" v-if="persona">
            <v-text-field
              v-model="persona.usuario_moodle"
              disabled
              outlined
              label="Nombre de usuario Actual"></v-text-field>
            <v-text-field :rules="fieldRules" outlined dense v-model="persona.nombres" label="Nombres"></v-text-field>
            <v-text-field
              :rules="fieldRules"
              outlined
              dense
              v-model="persona.pri_apellido"
              label="Primer Apellido"></v-text-field>
            <v-text-field outlined dense v-model="persona.seg_apellido" label="Segundo Apellido"></v-text-field>
            <v-text-field :rules="emailRules" outlined dense v-model="persona.email" label="Email"></v-text-field>
            <v-text-field
              :rules="fieldRules"
              outlined
              dense
              v-model="persona.telefono1"
              label="Telefono"></v-text-field>
            <div v-if="!register">
              <v-text-field
                :rules="fieldRules"
                outlined
                dense
                v-model="username"
                label="Nuevo Nombre de Usuario Moodle"></v-text-field>
              <v-text-field
                :rules="fieldRules"
                outlined
                dense
                label="Nueva Contraseña Moodle"
                v-model="password"
                prepend-icon="mdi-lock"
                :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (value = !value)"
                :type="value ? 'password' : 'text'"></v-text-field>
              <v-text-field
                :rules="confirmPasswordRules"
                outlined
                dense
                label="Confimar Nueva Contraseña"
                v-model="password2"
                prepend-icon="mdi-lock-outlined"
                :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (value = !value)"
                :type="value ? 'password' : 'text'"></v-text-field>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="success" rounded>
              <v-icon class="mr-1"> mdi-content-save</v-icon> Guardar Datos
            </v-btn>
            <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
              Cerrar <v-icon> mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
export default {
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      //api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
      dialog: false,
      valid: false,
      register: false,
      value: String,
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
      emailRules: [(v) => !!v || 'E-mail es Requerido', (v) => /.+@.+\..+/.test(v) || 'E-mail no válido'],
      confirmPasswordRules: [
        (value) => !!value || 'Contraseña Requerida',
        (value) => value === this.password || 'Las Contraseñas No coinciden',
      ],
      persona: null,
      //   ----new data-----
      username: null,
      password: null,
      password2: null,

      datamsg: '',
      plataforma: {},
      msgerr: '',
    };
  },
  methods: {
    showThisView(id, ins, register = false) {
      window.console.log(ins);
      this.getDatosPlataformas();
      this.register = register;
      this.dialog = true;
      const sql = gql`query{ getPersona(id:${id}){ id num_doc nombres pri_apellido seg_apellido telefono1 usuario_moodle clave_moodle email sexo tipo diestro profesiones{id}} }`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        this.persona = data.getPersona;
        this.persona.profesiones = this.persona.profesiones.map(({ id }) => id);
        delete this.persona.__typename;
        // window.console.log(data.getPersona, window.stringifyObject(this.persona));
        if (this.register) {
          this.username = this.persona.usuario_moodle;
          this.password = this.persona.clave_moodle;
        }
      });
    },
    updateDataMoodle() {
      if (this.$refs.formUser.validate()) {
        this.$root.$confirm.open('Guardar Nuevos Datos', 'Estas seguro ?', { color: 'orange' }).then((confirm) => {
          if (confirm) {
            this.msgerr = '';
            /*if( !this.plataforma.id ){
              this.getDatosPlataformas();
            }*/
            const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
              this.plataforma.id
            }/user`;
            let data = {
              current_username: this.persona.usuario_moodle,
              username: this.username,
              password: this.password,
              firstname: this.persona.nombres,
              lastname: `${this.persona.pri_apellido} ${this.persona.seg_apellido ? this.persona.seg_apellido : ''}`,
              email: this.persona.email,
              phone1: this.persona.telefono1,
            };
            // window.console.log(url, data);
            if (this.register) {
              xaxios
                .post(url, data)
                .then(() => this.updateDataSystem(this.persona, this.username, this.password))
                .catch(({ response }) =>
                  this.$root.$notify.show(response.data.error + ' en Moodle', { color: 'primary' }),
                );
            } else {
              xaxios
                .put(url, data)
                .then(() => this.updateDataSystem(this.persona, this.username, this.password))
                .catch(({ response }) => this.$root.$notify.show(response.data.error, { color: 'primary' }));
            }
          }
        });
      }
    },
    updateDataSystem(persona, new_username, new_password) {
      persona.usuario_moodle = new_username;
      persona.clave_moodle = new_password;
      const sql = gql`mutation{updatePersona(input:${window.stringifyObject(persona)}){ ok,  errors{message}}}`;
      this.$apollo
        .mutate({ mutation: sql })
        .then(({ data: { updatePersona } }) => {
          if (updatePersona.ok) {
            let sms = this.register ? 'Registro exitoso en moodle de' : 'Datos Modificados en Moodle y sistema de';
            persona.seg_apellido = persona.seg_apellido ? persona.seg_apellido : '';
            this.$root.$notify.show(`${sms} ${persona.nombres} ${persona.pri_apellido} ${persona.seg_apellido}`, {
              color: 'success',
            });
          } else {
            updatePersona.errors.forEach((error) => {
              this.$root.$notify.show(error.message, { color: 'red' });
            });
          }
          this.closeDialog();
        })
        .catch((err) => window.console.error(err));
    },
    closeDialog() {
      this.dialog = false;
      this.persona = null;
      this.username = null;
      this.password = null;
      this.password2 = null;
    },

    getDatosPlataformas() {
      this.$apollo
        .query({
          query: gql`
            query {
              getPlataformas {
                id
                nombre
                direccion
              }
            }
          `,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas;
          let plataforma_id = this.programa.plataforma_id;
          this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
          this.datamsg = `<b>Plataforma</b>: ${this.plataforma.nombre}`;
        })
        .catch((err) => {
          window.console.error(err);
          this.$root.$notify.show(`ERROR: getPlataformas(UpdateUserMoodle) ${err}`);
        });
    },

    simpleValues(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === null) {
          delete obj[key];
        }
      }
      return obj;
    },
  },
  mounted() {
    //this.getDatosPlataformas();
  },
};
</script>

<style>
</style>